module.exports = __webpack_public_path__ + "media/images/emblems/Oberbipp-coat_of_arms-eda85bf2f30ba0c995e69543803d0de8.svg";